import AbstractTask from '../abstract-task';
import { Method } from 'axios';

export default class ResetPasswordTask extends AbstractTask
{
    public token = '';
    public password = '';

    public async run(): Promise<boolean>
    {
        const response = await this.execute();

        if (response.status === 202)
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    protected get url(): string
    {
        return '/users/reset-password';
    }

    protected get method(): Method
    {
        return 'POST';
    }

    protected get authenticated(): boolean
    {
        return false;
    }

    protected get data(): {[key: string]: string}
    {
        return {
            token: this.token,
            password: this.password,
        };
    }
}